import { useState, useEffect } from 'react'
import { ref, get } from 'firebase/database'
import { db } from './firebase/firebase'

const useUserRole = (user) => {
  const [userRole, setUserRole] = useState(null)

  useEffect(() => {
    if (user) {
      const userId = user.uid
      const roleRef = ref(
        db,
        `projects/proj_iDtR68Uec2W1ohmGzgtMRo/data/DASHBOARD_User/${userId}/role`
      )

      get(roleRef)
        .then((snapshot) => {
          if (snapshot.exists()) {
            const role = snapshot.val()
            setUserRole(role)
          }
        })
        .catch((error) => {
          console.error('Error al obtener el rol del usuario:', error)
        })
    }
  }, [user])

  return userRole
}

export default useUserRole
